/**
 * Backbone.js model for the live-agent component which implements "instant chat" using the Salesforce
 * Live Agent facility.
 *
 * User: ckilbride
 * Date: 9/25/13
 */
define(function (require) {
  var BaseModel = require('common/models/OEBaseModel');

  return BaseModel.extend({
    'urlRoot': '/liveagent/config'
  });
});



//////////////////
// WEBPACK FOOTER
// ./js/components/live-agent/models/LiveAgentModel.js
// module id = 245
// module chunks = 14 26